import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['menu', 'trigger']

  close(event) {
    event?.preventDefault()

    leave(this.menuTarget).then(() => {
      this.triggerTarget.setAttribute('aria-expanded', 'false')
    })
  }

  isOpen() {
    return this.triggerTarget.getAttribute('aria-expanded') === 'true'
  }

  open(event) {
    event?.preventDefault()

    enter(this.menuTarget).then(() => {
      this.triggerTarget.setAttribute('aria-expanded', 'true')
    })
  }

  toggle(event) {
    event?.preventDefault()

    this.isOpen() ? this.close() : this.open()
  }
}
